import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { IVehicle } from 'src/interfaces/vehicle';
import { TSelectItem } from '../components/types';

/**
 * Maps the vehicles to a select item
 *
 * @param {IVehicle[]} vehicles
 * @return {*}  {TSelectItem[]}
 */
export const mapVehicles = (vehicles: IVehicle[]): TSelectItem[] =>
    vehicles.map((vehicle) => ({
        value: vehicle._id,
        label: capitalize(`${vehicle.make.name} ${vehicle.model}`),
    }));
